import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { TemplatePopupComponent } from './template-popup.component';

@NgModule({
    declarations: [TemplatePopupComponent],
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [TemplatePopupComponent],
})
export class TemplateModule {}
